
// HeaderHome.jsx
import React, { useEffect, useRef, useState } from "react";

export default function HeaderHome() {

  // Window resize listener

  // Auto-toggle sidebar

  // Initialize socket for incoming notifications

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <div className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-blue-600 bg-clip-text text-transparent">
              NexrBooks
            </div>
          </div>

          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <a href="/#features" className="text-gray-700 hover:text-blue-600 transition-colors duration-200">
                Features
              </a>
              <a href="/#pricing" className="text-gray-700 hover:text-blue-600 transition-colors duration-200">
                Pricing
              </a>
              <a href="/#about" className="text-gray-700 hover:text-blue-600 transition-colors duration-200">
                About
              </a>
              <a href="/#contact" className="text-gray-700 hover:text-blue-600 transition-colors duration-200">
                Contact
              </a>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <a href='/login'>
              <button className="hidden md:inline-flex inline-flex items-center justify-center font-medium rounded-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 bg-gray-100 text-gray-900 hover:bg-gray-200 focus:ring-gray-500 px-4 py-2 text-base">
                Sign In
              </button>
            </a>

            <a href='/register'>
              <button className="inline-flex items-center justify-center font-medium rounded-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 bg-gradient-to-r from-blue-600 to-blue-600 text-white hover:from-blue-700 hover:to-blue-700 focus:ring-blue-500 px-4 py-2 text-base">
                Get Started
              </button>
            </a>

          </div>
        </div>
      </div>
    </nav>

  );
}

